import Container from "@components/ui/container.tsx";
import { JobAlertsPanel, type JobAlertsPanelProps } from "@components/job_alerts/panel.tsx";
import { JobsTabs } from "@components/job_search/jobs_tabs.tsx";
import { TabSearchHeader } from "@components/job_search/tab_search_header.tsx";
import { type RecentSearch } from "@/types/job_search/recent_searches";

export type AlertsTabProps = JobAlertsPanelProps & {
  recentSearches: RecentSearch[];
  savedJobsEnabled: boolean;
};

export const AlertsTab = ({ recentSearches, savedJobsEnabled, ...panelProps }: AlertsTabProps) => (
  <>
    <TabSearchHeader recentSearches={recentSearches} />
    <JobsTabs active="alerts" savedJobsEnabled={savedJobsEnabled} newJobAlertsEnabled />
    <Container className="!max-w-[1550px] !pt-0">
      <JobAlertsPanel {...panelProps} variant="tab" />
    </Container>
  </>
);
